
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useApiInit } from '../hooks/useApiInit';
import LoadingSpinner from './LoadingSpinner';
import AppRoutes from './AppRoutes';

const AppContent = () => {
  const { isLoading } = useAuth();
  
  // Initialize API polling when user is authenticated
  useApiInit();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return <AppRoutes />;
};

export default AppContent;
